// extracted by mini-css-extract-plugin
export default {"transferTitle":"recorderVideoPreviewModal_transferTitle__P3dTq","transferErrorTitle":"recorderVideoPreviewModal_transferErrorTitle__JZTnw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"transferTitle\":\"recorderVideoPreviewModal_transferTitle__P3dTq\",\"transferErrorTitle\":\"recorderVideoPreviewModal_transferErrorTitle__JZTnw\"}";
        // 1793760840507
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  